var _a;
var UpdatedFreeBetDataItemKeys;
(function (UpdatedFreeBetDataItemKeys) {
    UpdatedFreeBetDataItemKeys["BET_AMOUNT"] = "betAmount";
    UpdatedFreeBetDataItemKeys["MAX_PAYOUT"] = "maxPayout";
    UpdatedFreeBetDataItemKeys["FREE_BET_ID"] = "freeBetId";
    UpdatedFreeBetDataItemKeys["CURRENT_INDEX"] = "currentIndex";
    UpdatedFreeBetDataItemKeys["FREE_BET_TYPE"] = "freeBetType";
    UpdatedFreeBetDataItemKeys["IS_SHOW_POP_UP"] = "isShowPopUp";
    UpdatedFreeBetDataItemKeys["IS_BET_ACCEPTED"] = "isBetAccepted";
    UpdatedFreeBetDataItemKeys["CASH_OUT_AMOUNT"] = "cashOutAmount";
    UpdatedFreeBetDataItemKeys["FREE_BET_MIN_ODD"] = "freeBetMinOdd";
    UpdatedFreeBetDataItemKeys["IS_ALREADY_SEEN_POP_UP"] = "isAlreadySeenPopUp";
    UpdatedFreeBetDataItemKeys["IS_AUTO_CASH_OUT"] = "isAutoCashOut";
    UpdatedFreeBetDataItemKeys["IS_HALF_CASH_OUT"] = "isHalfCashOut";
    UpdatedFreeBetDataItemKeys["HALF_CASH_OUTED_WIN_AMOUNT"] = "halfCashOutedWinAmount";
})(UpdatedFreeBetDataItemKeys || (UpdatedFreeBetDataItemKeys = {}));
var BetSectionIndexes;
(function (BetSectionIndexes) {
    BetSectionIndexes[BetSectionIndexes["FIRST"] = 0] = "FIRST";
    BetSectionIndexes[BetSectionIndexes["SECOND"] = 1] = "SECOND";
    BetSectionIndexes[BetSectionIndexes["THIRD"] = 2] = "THIRD";
    BetSectionIndexes[BetSectionIndexes["FOURTH"] = 3] = "FOURTH";
})(BetSectionIndexes || (BetSectionIndexes = {}));
var FreeBetInitialData = (_a = {},
    _a[BetSectionIndexes.FIRST] = {
        isShowPopUp: false,
        maxPayout: null,
        freeBetId: null,
        freeBetType: null,
        currentIndex: null,
        freeBetMinOdd: null,
        isBetAccepted: false,
        betAmount: null,
        cashOutAmount: null,
        isAlreadySeenPopUp: false,
        isAutoCashOut: false,
        isHalfCashOut: false,
        halfCashOutedWinAmount: 0,
    },
    _a[BetSectionIndexes.SECOND] = {
        isShowPopUp: false,
        maxPayout: null,
        freeBetId: null,
        freeBetType: null,
        currentIndex: null,
        freeBetMinOdd: null,
        isBetAccepted: false,
        betAmount: null,
        cashOutAmount: null,
        isAlreadySeenPopUp: false,
        isAutoCashOut: false,
        isHalfCashOut: false,
        halfCashOutedWinAmount: 0,
    },
    _a[BetSectionIndexes.THIRD] = {
        isShowPopUp: false,
        maxPayout: null,
        freeBetId: null,
        freeBetType: null,
        currentIndex: null,
        freeBetMinOdd: null,
        isBetAccepted: false,
        betAmount: null,
        cashOutAmount: null,
        isAlreadySeenPopUp: false,
        isAutoCashOut: false,
        isHalfCashOut: false,
        halfCashOutedWinAmount: 0,
    },
    _a[BetSectionIndexes.FOURTH] = {
        isShowPopUp: false,
        maxPayout: null,
        freeBetId: null,
        freeBetType: null,
        currentIndex: null,
        freeBetMinOdd: null,
        isBetAccepted: false,
        betAmount: null,
        cashOutAmount: null,
        isAlreadySeenPopUp: false,
        isAutoCashOut: false,
        isHalfCashOut: false,
        halfCashOutedWinAmount: 0,
    },
    _a);

export { BetSectionIndexes, FreeBetInitialData, UpdatedFreeBetDataItemKeys };
